import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import PropTypesImmutable from 'react-immutable-proptypes';
import { Form, Field } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import {
  TextField,
  ClassificatorField,
  RadioField,
  DateField,
} from '../../atoms';
import { Row, Col } from 'antd';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { tAddEquipment } from '../../i18n';
import {
  FORM_TECHNICAL_INFORMATION,
  technicalInformationFormFields,
  certificateFormFields,
} from '../../constants/formsAddEquipment';
import { parseNumber, parseMegawatt } from '../../utils/formHelpers';
import { RegisterActions, FileUpload } from '../../components';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import economicCertificateName from '../../constants/classificators/economicCertificateName';
import { updateProductionUnit } from '../../actions/actionCreators/productionUinitActionCreators';
import economicCertificateClassificator from '../../constants/classificators/economicCertificate';
import * as certificateSelectors from '../../reducers/productionUnitCertificatesReducer';
import * as certificateActions from '../../actions/actionCreators/productionUnitCertificatesActionCreators';
import { getProductionUnitCertificates } from '../../schemas/productionUnitCertificate';
import { FILE_URL } from '../../constants/file';
import validate from './validateSchema';
import hydroValidate from './validateHydroSchema';
import './addEquipmentTechnicalInformation.css';
import {
  economicCertificate,
  hydrogenTechnologyType,
} from '../../constants/classificators';

import FormStateToRedux from '../FormStateToRedux';
import {
  formValueSelector,
  updateFormState,
} from '../../reducers/reactFinalFormReducer';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import { isEqual } from 'lodash/fp';
import SubmitErrorToast from '../SubmitErrorToast';
import { FormSpy } from 'react-final-form/dist';

const tCertTypeKey = (key) =>
  `common:classificators.economicCertificateName.${key}`;

const mapCertificatesToFiles = (certificates) => {
  return certificates.toJS().map((d) => ({
    uid: get(d, certificateFormFields.FILE),
    name: get(d, certificateFormFields.NAME),
    status: 'done',
    url: `${FILE_URL}/${get(d, certificateFormFields.FILE)}`,
  }));
};

const isCertificateCustom = (certificate) =>
  ![economicCertificateName.iscc, economicCertificateName.redcert].includes(
    certificate
  );

export class AddEquipmentTechnicalInformation extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    hasPrevious: PropTypes.bool,
    hasDone: PropTypes.bool,
    goPrevious: PropTypes.func,
    economicCertificate: PropTypes.string,
    certificateName: PropTypes.string,
    certificates: PropTypesImmutable.list,
    toBeRemovedCertificates: PropTypesImmutable.list,
    fetchProductionUnitCertificates: PropTypes.func.isRequired,
    initialValues: PropTypesImmutable.map.isRequired,
    isFilesLoading: PropTypes.bool.isRequired,
    productionUnit: PropTypesImmutable.map,
    inEditForNotAdmin: PropTypes.bool.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    showRequestChangeModal: PropTypes.func,
    isHydrogenContext: PropTypes.bool,
    addProductionUnitCertificate: PropTypes.func.isRequired,
    deleteProductionUnitCertificate: PropTypes.func.isRequired,
    updateProductionUnit: PropTypes.func.isRequired,
    updateFormState: PropTypes.func.isRequired,
    onSubmitSuccess: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const legacy = this.getValidator(props);
    this.validate = makeRffValidateFromLegacy(
      legacy,
      props,
      props.initialValues
    );
  }

  state = {
    hydrogenTechnologyValue: this.props.productionUnit.hydrogenTechnologyType,
  };

  static defaultProps = {
    certificates: List(),
  };

  componentDidMount = () => {
    const { fetchProductionUnitCertificates, initialValues, updateFormState } =
      this.props;
    const id = initialValues.get('id');

    if (id) fetchProductionUnitCertificates(id);
    updateFormState(FORM_TECHNICAL_INFORMATION, {
      values: initialValues.toJS(),
    });
  };

  onFileChange = (info) => {
    const {
      addProductionUnitCertificate,
      initialValues,
      deleteProductionUnitCertificate,
    } = this.props;

    if (info.file.status === 'done') {
      addProductionUnitCertificate({
        [certificateFormFields.FILE]: info.file.response,
        [certificateFormFields.PRODUCTION_UNIT_ID]: initialValues.get('id'),
        [certificateFormFields.NAME]: info.file.name,
      });
    } else if (info.file.status === 'removed') {
      deleteProductionUnitCertificate(info.file);
    }
  };

  isCustomCertificateShow = () => {
    const { economicCertificate, certificateName } = this.props;

    return (
      economicCertificate !== economicCertificateClassificator.UNCERTIFIED &&
      (economicCertificate !==
        economicCertificateClassificator.VOLUNTARY_SCHEME ||
        certificateName === economicCertificateName.other)
    );
  };

  getValidator = (props) =>
    props.isHydrogenContext ? hydroValidate : validate;

  onSubmit = async (values) => {
    const {
      isHydrogenContext,
      certificates,
      toBeRemovedCertificates,
      updateProductionUnit,
      onSubmitSuccess,
      dispatch,
    } = this.props;

    if (
      !isHydrogenContext &&
      certificates.isEmpty() &&
      values[technicalInformationFormFields.ECONOMIC_CERTIFICATE] !==
        economicCertificateClassificator.UNCERTIFIED
    ) {
      return {
        [FORM_ERROR]: tAddEquipment('technicalInformation.certificateError'),
      };
    }

    const customCertificate =
      values[technicalInformationFormFields.CUSTOM_CERTIFICATE_NAME];
    let passedValues = { ...values };

    if (
      values[technicalInformationFormFields.ECONOMIC_CERTIFICATE] ===
      economicCertificateClassificator.UNCERTIFIED
    ) {
      passedValues = {
        ...passedValues,
        [technicalInformationFormFields.CERTIFICATE_END_DATE]: null,
        [technicalInformationFormFields.CERTIFICATE_NAME]: null,
        [technicalInformationFormFields.CUSTOM_CERTIFICATE_NAME]: null,
      };
    } else if (
      isCertificateCustom(
        values[technicalInformationFormFields.CERTIFICATE_NAME]
      ) &&
      customCertificate
    ) {
      passedValues = {
        ...passedValues,
        [technicalInformationFormFields.CERTIFICATE_NAME]: customCertificate,
      };
    }

    if (!toBeRemovedCertificates.isEmpty()) {
      passedValues = {
        ...passedValues,
        [technicalInformationFormFields.IDS_OF_FILES]: toBeRemovedCertificates
          .map((o) => o.uid)
          .toJS(),
      };
    }

    try {
      const result = await updateProductionUnit(passedValues);
      onSubmitSuccess?.(result, dispatch, this.props);
    } catch (err) {
      const msg = (err && (err.message || String(err))) || 'Submit failed';
      return { [FORM_ERROR]: msg };
    }
  };

  render() {
    const {
      hasPrevious,
      hasDone,
      goPrevious,
      t,
      certificates,
      isFilesLoading,
      inEditForNotAdmin,
      isEditMode,
      isAdmin,
      showRequestChangeModal,
      isHydrogenContext,
      productionUnit,
      initialValues,
    } = this.props;
    const { hydrogenTechnologyValue } = this.state;

    const isElectrolysis =
      hydrogenTechnologyValue === hydrogenTechnologyType.ELECTROLYSIS ||
      productionUnit.get('hydrogenTechnologyType') ===
        hydrogenTechnologyType.ELECTROLYSIS;

    return (
      <div className="production-unit-tech-info">
        <Form
          initialValues={initialValues.toJS()}
          initialValuesEqual={isEqual}
          validate={this.validate}
          onSubmit={this.onSubmit}
          render={({
            handleSubmit,
            submitFailed,
            submitError,
            submitCount,
          }) => (
            <form onSubmit={handleSubmit}>
              <SubmitErrorToast
                submitFailed={submitFailed}
                submitError={submitError}
                submitCount={submitCount}
              />
              <FormStateToRedux form={FORM_TECHNICAL_INFORMATION} />
              <h2>
                {isEditMode
                  ? t('technicalInformation.titleEdit')
                  : t('technicalInformation.title')}
              </h2>
              <Row gutter={32}>
                <Col span={12}>
                  {isHydrogenContext ? (
                    <Field
                      name={
                        technicalInformationFormFields.HYDROGEN_TECHNOLOGY_TYPE
                      }
                      subscription={{ value: true, meta: true }}
                    >
                      {({ input, meta }) => (
                        <ClassificatorField
                          label={t(
                            'technicalInformation.hydrogenTechnologyType'
                          )}
                          classificatorType={
                            ClassificatorField.types.hydrogenTechnologyType
                          }
                          required
                          disabled={
                            inEditForNotAdmin ||
                            productionUnit.get('hydrogenTechnologyType')
                          }
                          input={{
                            ...input,
                            onChange: (val) => {
                              this.setState({ hydrogenTechnologyValue: val });
                              input.onChange(val);
                            },
                          }}
                          meta={meta}
                        />
                      )}
                    </Field>
                  ) : (
                    <Field
                      label={t('technicalInformation.cleaningTechnologyType')}
                      name={
                        technicalInformationFormFields.CLEANING_TECHNOLOGY_TYPE
                      }
                      component={ClassificatorField}
                      classificatorType={
                        ClassificatorField.types.cleaningTechnologyType
                      }
                      required
                      disabled={
                        inEditForNotAdmin ||
                        productionUnit.get('technologyType')
                      }
                    />
                  )}
                </Col>
                <Col span={12}>
                  <Field
                    name={technicalInformationFormFields.NOMINAL_POWER}
                    component={TextField}
                    addonAfter={t('technicalInformation.nominalPower.units')}
                    type="text"
                    parse={parseMegawatt}
                    label={t('technicalInformation.nominalPower.label')}
                    required
                    disabled={inEditForNotAdmin}
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  {!isHydrogenContext && (
                    <Field
                      name={technicalInformationFormFields.ECONOMIC_CERTIFICATE}
                      component={ClassificatorField}
                      label={t('technicalInformation.economicCertificate')}
                      classificatorType={
                        ClassificatorField.types.economicCertificate
                      }
                      required
                      disabled={inEditForNotAdmin}
                    />
                  )}
                  {isElectrolysis && (
                    <Field
                      label={t(
                        'technicalInformation.electrolysisTechnologyType'
                      )}
                      name={
                        technicalInformationFormFields.ELECTROLYSIS_TECHNOLOGY_TYPE
                      }
                      component={ClassificatorField}
                      classificatorType={
                        ClassificatorField.types.electrolysisTechnologyType
                      }
                      required
                      disabled={
                        inEditForNotAdmin ||
                        productionUnit.get('electrolysisTechnologyType')
                      }
                    />
                  )}
                </Col>
                <Col span={12}>
                  {!isHydrogenContext && (
                    <Field
                      name={
                        technicalInformationFormFields.SELF_SUFFICIENT_WEIGHT
                      }
                      component={TextField}
                      addonAfter="%"
                      type="text"
                      parse={parseNumber}
                      label={t('technicalInformation.selfSufficientWeight')}
                      required
                      disabled={inEditForNotAdmin}
                    />
                  )}
                </Col>
              </Row>
              {isHydrogenContext && (
                <Row gutter={32}>
                  <Col span={12}>
                    <Field
                      name={technicalInformationFormFields.RFNBO}
                      component={RadioField}
                      required
                      options={[
                        {
                          value: true,
                          label: t('technicalInformation.rfnbo.trueLabel'),
                        },
                        {
                          value: false,
                          label: t('technicalInformation.rfnbo.falseLabel'),
                        },
                      ]}
                      type="text"
                      label={t('technicalInformation.rfnbo.label')}
                      disabled={inEditForNotAdmin}
                    />
                  </Col>
                </Row>
              )}
              {!isHydrogenContext && (
                <Row gutter={32}>
                  {this.props.economicCertificate ===
                    economicCertificateClassificator.VOLUNTARY_SCHEME && (
                    <Col span={12}>
                      <Field
                        name={technicalInformationFormFields.CERTIFICATE_NAME}
                        component={RadioField}
                        label={t('technicalInformation.certificateName')}
                        required
                        disabled={inEditForNotAdmin}
                        options={[
                          {
                            value: economicCertificateName.redcert,
                            label: t(
                              tCertTypeKey(economicCertificateName.redcert)
                            ),
                          },
                          {
                            value: economicCertificateName.iscc,
                            label: t(
                              tCertTypeKey(economicCertificateName.iscc)
                            ),
                          },
                          {
                            value: economicCertificateName.other,
                            label: t(
                              tCertTypeKey(economicCertificateName.other)
                            ),
                          },
                        ]}
                      />
                    </Col>
                  )}
                  <FormSpy subscription={{ values: true }}>
                    {({ values, form }) => {
                      const certificate =
                        values?.[
                          technicalInformationFormFields.ECONOMIC_CERTIFICATE
                        ];
                      const certificateName =
                        values?.[
                          technicalInformationFormFields.CERTIFICATE_NAME
                        ];
                      const customCertName =
                        values?.[
                          technicalInformationFormFields.CUSTOM_CERTIFICATE_NAME
                        ];
                      // set CUSTOM_CERTIFICATE_NAME to undefined when not visible
                      if (
                        certificate === economicCertificate.UNCERTIFIED ||
                        (certificate === economicCertificate.VOLUNTARY_SCHEME &&
                          certificateName !== economicCertificateName.other)
                      ) {
                        if (customCertName)
                          form.change(
                            technicalInformationFormFields.CUSTOM_CERTIFICATE_NAME,
                            undefined
                          );
                      }
                      if (certificate === economicCertificate.UNCERTIFIED) {
                        form.change(
                          technicalInformationFormFields.CERTIFICATE_END_DATE,
                          undefined
                        );
                        form.change(
                          technicalInformationFormFields.CERTIFICATE_NAME,
                          undefined
                        );
                      }
                      // set CERTIFICATE_NAME to OTHER when not VOLUNTARY_SCHEME or UNCERTIFIED
                      if (
                        certificate !== economicCertificate.VOLUNTARY_SCHEME &&
                        certificate !== economicCertificate.UNCERTIFIED
                      ) {
                        form.change(
                          technicalInformationFormFields.CERTIFICATE_NAME,
                          economicCertificateName.other
                        );
                      }
                      return null;
                    }}
                  </FormSpy>
                  {this.isCustomCertificateShow() && (
                    <Col span={12}>
                      <Field
                        name={
                          technicalInformationFormFields.CUSTOM_CERTIFICATE_NAME
                        }
                        component={TextField}
                        type="text"
                        label={t('technicalInformation.certificateName')}
                        required
                        disabled={inEditForNotAdmin}
                      />
                    </Col>
                  )}
                </Row>
              )}
              {!isHydrogenContext &&
                this.props.economicCertificate !==
                  economicCertificateClassificator.UNCERTIFIED && (
                  <Row gutter={32}>
                    <Col span={12}>
                      <Field
                        className="date-field"
                        name={
                          technicalInformationFormFields.CERTIFICATE_END_DATE
                        }
                        component={DateField}
                        showTime={false}
                        label={t('technicalInformation.certificateEndDate')}
                        required
                        disabled={inEditForNotAdmin}
                      />
                    </Col>
                  </Row>
                )}
              {this.props.economicCertificate !==
                economicCertificateClassificator.UNCERTIFIED && (
                <Row gutter={32}>
                  <Col className="gutter-row" span={12}>
                    <h3 className="form-register-additional__document-title">
                      {t('technicalInformation.uploadTitle')}
                    </h3>
                    {!isFilesLoading && (
                      <FileUpload
                        t={t}
                        onChange={this.onFileChange}
                        defaultFileList={mapCertificatesToFiles(certificates)}
                        showUploadList={{ showRemoveIcon: !inEditForNotAdmin }}
                        disabled={inEditForNotAdmin}
                      />
                    )}
                  </Col>
                </Row>
              )}
              {this.props.toBeRemovedCertificates.size !== 0 && (
                <Row gutter={32}>
                  <Col className="gutter-row pt-3" span={12}>
                    <h3 className="dfn">
                      {`${t(
                        'technicalInformation.toBeRemovedCertificatesTitle'
                      )}:`}
                    </h3>
                    {this.props.toBeRemovedCertificates.toJS().map((d, i) => (
                      <div key={i} className="deleted-item">
                        {get(d, certificateFormFields.NAME)}
                      </div>
                    ))}
                  </Col>
                </Row>
              )}
              <RegisterActions
                showRequestChangeModal={showRequestChangeModal}
                hasPrevious={hasPrevious}
                hasDone={hasDone}
                isEditMode={isEditMode}
                isAdmin={isAdmin}
                goPrevious={goPrevious}
                showSaveButton={isAdmin || !isEditMode}
                t={t}
              />
            </form>
          )}
        />
      </div>
    );
  }
}

const selector = formValueSelector(FORM_TECHNICAL_INFORMATION);

const mapStateToProps = (state, ownProps) => {
  const values = selector(state);
  let initialValues = ownProps.productionUnit;
  if (
    isCertificateCustom(
      initialValues.get(technicalInformationFormFields.CERTIFICATE_NAME)
    )
  ) {
    initialValues = initialValues.merge({
      [technicalInformationFormFields.CERTIFICATE_NAME]:
        economicCertificateName.other,
      [technicalInformationFormFields.CUSTOM_CERTIFICATE_NAME]:
        initialValues.get(technicalInformationFormFields.CERTIFICATE_NAME),
    });
  }
  if (
    initialValues.get(technicalInformationFormFields.ECONOMIC_CERTIFICATE) ===
    economicCertificateClassificator.UNCERTIFIED
  ) {
    initialValues = initialValues.merge({
      [technicalInformationFormFields.CERTIFICATE_END_DATE]: undefined,
      [technicalInformationFormFields.CERTIFICATE_NAME]: undefined,
      [technicalInformationFormFields.CUSTOM_CERTIFICATE_NAME]: undefined,
    });
  }

  return {
    economicCertificate: values.get(
      technicalInformationFormFields.ECONOMIC_CERTIFICATE
    ),
    certificateName: values.get(
      technicalInformationFormFields.CERTIFICATE_NAME
    ),
    isFilesLoading: getLoadingSelector(
      certificateSelectors.getProductionUnitCertificatesAddState,
      certificateSelectors.getProductionUnitCertificatesList
    )(state),
    certificates: getProductionUnitCertificates(
      state,
      certificateSelectors.getProductionUnitCertificatesList(state)
    ),
    toBeRemovedCertificates:
      certificateSelectors.getProductionUnitCertificatesDeleteState(state),
    initialValues,
  };
};

const mapDispatchToProps = {
  ...certificateActions,
  updateProductionUnit,
  updateFormState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEquipmentTechnicalInformation);
